import { chatBotReturnFromLiveAgentChat } from './quriobot';
import {
  getLiveAgentId,
  liveAgentSrcUrl
} from '../../../utils/quriobot/quriobot_config';

let MAIN_SCRIPT_ADDED = false;
let LIVE_AGENT_BUTTON_VISIBLE = false;

let lastOpenParams = {
  noQuriobot: false,
  loggedInMode: false,
  language: null
};

let BUTTON_CREATED = false;

export const isLiveAgentButtonVisible = () => LIVE_AGENT_BUTTON_VISIBLE;

export const isLiveAgentChatOpen = () =>
  !!window.LiveAgent &&
  !!window.LiveAgent.instance &&
  window.LiveAgent.instance.hasOpenedWidget();

export const showLiveAgentChat = (
  noQuriobot,
  loggedInMode,
  language,
  email = '',
  firstName = '',
  lastName = '',
  caseId = ''
) => {
  const lang = ['DE', 'EN', 'NL'].includes(language) ? language : 'EN';

  if (!MAIN_SCRIPT_ADDED) {
    MAIN_SCRIPT_ADDED = true;
    createMainScript(
      noQuriobot,
      loggedInMode,
      lang,
      email,
      firstName,
      lastName,
      caseId
    );
  } else {
    if (!noQuriobot || !LIVE_AGENT_BUTTON_VISIBLE) {
      hideCurrentLiveAgentButton(loggedInMode);
      showAgent(
        noQuriobot,
        loggedInMode,
        lang,
        email,
        firstName,
        lastName,
        caseId
      );
    }
  }
};

export const hideCurrentLiveAgentButton = () => {
  if (!LIVE_AGENT_BUTTON_VISIBLE) {
    return;
  }
  if (isLiveAgentChatOpen()) {
    return;
  }
  LIVE_AGENT_BUTTON_VISIBLE = false;

  const button = window.LiveAgent.instance.getAllWidget(getLiveAgentId())[0];

  button.originalCloseFunction_();
  window.LiveAgent.instance.getAllWidget(
    getLiveAgentId()
  )[0].buttonDiv.style.display = 'none';
};

const showAgent = (
  noQuriobot,
  loggedInMode,
  language,
  email,
  firstName,
  lastName,
  caseId
) => {
  window.LiveAgent.clearAllUserDetails();

  window.LiveAgent.setUserDetails(email, firstName, lastName);
  window.LiveAgent.addContactField('caseid', caseId);
  window.LiveAgent.addTicketField('caseid', caseId);

  if (!BUTTON_CREATED) {
    BUTTON_CREATED = true;
    let button = window.LiveAgent.createButton(
      getLiveAgentId(),
      document.scripts[document.scripts.length - 1]
    );

    button.originalCloseFunction_ = button.onCloseFunction_;
    button.onCloseFunction_ = function() {
      if (!LIVE_AGENT_BUTTON_VISIBLE) {
        return;
      }
      button.originalCloseFunction_();

      if (!lastOpenParams.noQuriobot) {
        LIVE_AGENT_BUTTON_VISIBLE = false;

        window.LiveAgent.instance.getAllWidget(
          getLiveAgentId()
        )[0].buttonDiv.style.display = 'none';

        setTimeout(() => {
          chatBotReturnFromLiveAgentChat();
        }, 100);
      } else {
        window.LiveAgent.instance.getAllWidget(
          getLiveAgentId()
        )[0].buttonDiv.style.display = 'block';
      }
    };

    if (!noQuriobot) {
      setTimeout(() => {
        button.buttonDiv.click();
      }, 1000);
    }
  } else {
    window.LiveAgent.instance.getAllWidget(
      getLiveAgentId()
    )[0].buttonDiv.style.display = 'block';

    if (!noQuriobot) {
      window.LiveAgent.instance.getAllWidget(getLiveAgentId())[0].onClick();
    }
  }
  lastOpenParams = { noQuriobot, loggedInMode, language };

  LIVE_AGENT_BUTTON_VISIBLE = true;
};

const createMainScript = (
  noQuriobot,
  loggedInMode,
  language,
  email,
  firstName,
  lastName,
  caseId
) => {
  let script = document.createElement('script');

  script.id = 'la_x2s6df8d';
  script.src = liveAgentSrcUrl;
  script.onload = script.onreadystatechange = function() {
    const rs = this.readyState;
    if (rs && rs !== 'complete' && rs !== 'loaded') {
      return;
    }
    showAgent(
      noQuriobot,
      loggedInMode,
      language,
      email,
      firstName,
      lastName,
      caseId
    );
  };

  const lastScript = document.scripts[document.scripts.length - 1];
  lastScript.parentElement.insertBefore(script, lastScript.nextSibling);
};
